import { Event } from '@/types';
import { UAParser } from 'ua-parser-js';

export function getDeviceInfo(): Event['device'] {
  const parser = new UAParser(navigator.userAgent);
  const result = parser.getResult();

  return {
    id: crypto.randomUUID(),
    type: (result.device.type || 'desktop') as Event['device']['type'], // 'mobile' | 'tablet' | 'desktop' | 'smarttv' | 'wearable' | 'embedded'
    os: {
      name: (result.os.name || 'Unknown') as Event['device']['os']['name'],
      version: result.os.version || '',
    },
    browser: {
      name: (result.browser.name || 'Unknown') as
        | Event['device']['browser']['name']
        | 'Other',
      version: (result.browser.version ||
        '') as Event['device']['browser']['version'],
    },
    engine: {
      name: result.engine.name || '',
      version: result.engine.version || '',
    },
    language: navigator.language,
    userAgent: navigator.userAgent,
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      pixel_ratio: window.devicePixelRatio,
    },
  };
}
